export default __webpack_public_path__ + "media/splashpage/bg-full-left-purple-7754d575.svg";